import { render } from "./TopbarDefault.vue?vue&type=template&id=1a84542a&scoped=true"
import script from "./TopbarDefault.vue?vue&type=script&lang=js"
export * from "./TopbarDefault.vue?vue&type=script&lang=js"

import "./TopbarDefault.vue?vue&type=style&index=0&id=1a84542a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a84542a"]])

export default __exports__